import React from 'react';
import './Page.css';

const Donate = () => {
  return (
    <div className="page">
      <h1>Donate</h1>
      <p>Support the AG Foundation Annual Golf Classic.</p>
    </div>
  );
};

export default Donate;

